import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { FirebaseConfig } from './types';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5555';

interface FirebaseInitResult {
  app: FirebaseApp;
  auth: Auth;
  db: Firestore;
}

// Fetch Firebase config from backend (same approach as web version)
export const initializeFirebase = async (): Promise<FirebaseInitResult> => {
  if (app && auth && db) return { app, auth, db };

  try {
    const response = await fetch(`${API_BASE_URL}/api/firebase-config`);
    const firebaseConfig: FirebaseConfig = await response.json();

    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);

    return { app, auth, db };
  } catch (error) {
    console.error('Failed to fetch Firebase config:', error);
    throw error;
  }
};

export const getAuthInstance = (): Auth => {
  if (!auth) {
    throw new Error('Firebase not initialized. Call initializeFirebase() first.');
  }
  return auth;
};

export const getFirestoreInstance = (): Firestore => {
  if (!db) {
    throw new Error('Firebase not initialized. Call initializeFirebase() first.');
  }
  return db;
};

export { auth, db };
